import "./App.css";
import "./assets/fonts/pretendardvariable-dynamic-subset.css";
import { Outlet } from "react-router";
import { QueryClientProvider } from "@tanstack/react-query";
import { useEffect } from "react";
import { useWindowStore } from "./store/WindowWidth";
import { queryClient } from "./api/query";

export const App = () => {
  useEffect(() => {
    const handleResize = () => {
      useWindowStore.getState().setWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <main className="relative flex flex-1 flex-col w-full h-full m-auto bg-gray-g30 overflow-auto">
        <Outlet />
      </main>
    </QueryClientProvider>
  );
};
